/**
 * SDK Documentation sidebar navigation.
 * Follows the react.dev/reference pattern with categorised links.
 */

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Code2, ChevronDown, ChevronRight } from 'lucide-react';
import { SDK_CATEGORIES, SDK_ENTRIES } from '../data/sdk-docs';

export default function SdkSidebar() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  const toggle = (slug: string) =>
    setCollapsed((prev) => ({ ...prev, [slug]: !prev[slug] }));

  /** Derive current slug from pathname */
  const currentSlug = location.pathname.replace('/sdk/', '').replace('/sdk', '');

  return (
    <aside className="sdk-sidebar">
      <Link to="/" className="sdk-sidebar-brand">
        <Code2 size={24} />
        <span>token-kit</span>
      </Link>

      <div className="sdk-sidebar-label">SDK Reference</div>

      {/* Overview link */}
      <Link
        to="/sdk"
        className={`sdk-sidebar-link ${currentSlug === '' ? 'active' : ''}`}
      >
        Overview
      </Link>

      {SDK_CATEGORIES.map((cat) => {
        const isOpen = !collapsed[cat.slug];
        const entries = cat.items
          .map((slug) => SDK_ENTRIES.find((e) => e.slug === slug))
          .filter(Boolean) as typeof SDK_ENTRIES;

        return (
          <div key={cat.slug} className="sdk-sidebar-group">
            <button
              className="sdk-sidebar-group-header"
              onClick={() => toggle(cat.slug)}
            >
              <span>{cat.name}</span>
              {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
            </button>

            {isOpen && (
              <div className="sdk-sidebar-group-items">
                {entries.map((entry) => (
                  <Link
                    key={entry.slug}
                    to={`/sdk/${entry.slug}`}
                    className={`sdk-sidebar-link ${currentSlug === entry.slug ? 'active' : ''}`}
                  >
                    <span className={`sdk-kind-dot ${entry.kind}`} />
                    {entry.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}

      <div className="sdk-sidebar-footer">
        <Link to="/register" className="btn btn-accent btn-sm btn-block">
          Get API Key
        </Link>
      </div>
    </aside>
  );
}
